// Core
import React, { Component } from 'react';
import '../styles/styles.scss';

class Error extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg : this.props.message,
      subErrorMsg : this.props.subMessage
    }
  }

  render() {
    return(
      <>
        <div className="pref-container">
          <h3>{this.state.errorMsg}</h3>
          {this.state.subErrorMsg != null && <p>{this.state.subErrorMsg}</p>}
        </div>
      </>
    );
  }
}
export default Error;